// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import { ActionButton } from '../ActionButton';
import ArticleActionItem from './partials/ArticleActionItem';
import { BootstrapPopover } from '../../../dsl/bootstrap';
/**
 * @author Sebastian Dziechciarz, Stanisław Gregor
 */
let ArticleActions = class ArticleActions extends Vue {
    mounted() {
        this.watchSize();
    }
    beforeDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.unobserve(this.containerRef);
        }
    }
    watchSize() {
        this.resizeObserver = new ResizeObserver(([entry]) => {
            var _a;
            if ((_a = entry.contentBoxSize) === null || _a === void 0 ? void 0 : _a.length) {
                this.getHeight();
            }
        });
        this.resizeObserver.observe(this.containerRef);
    }
    getHeight() {
        const height = typeof this.containerRef !== 'undefined'
            ? this.containerRef.clientHeight + 'px' : undefined;
        if (typeof height !== 'undefined') {
            document.documentElement.style.setProperty('--actions-height', height);
        }
    }
};
__decorate([
    Prop({ type: Array, required: true })
], ArticleActions.prototype, "actions", void 0);
__decorate([
    Ref('container')
], ArticleActions.prototype, "containerRef", void 0);
ArticleActions = __decorate([
    Component({
        name: 'ArticleActions',
        components: { ActionButton, ArticleActionItem, BootstrapPopover },
        template: `
    <ul class="article-actions list-inline" ref="container">
      <li v-for="(action, i) in actions" :key="i" class="article-actions__item"
          :class="{ 'd-none d-md-inline-block': action.hideForMobile }">
        <BootstrapPopover v-if="action.children" position="right" triggerMode="click">
          <div slot="content">
            <ul class="article-actions__list list-inline">
              <ArticleActionItem v-for="item in action.children" :key="item.icon" v-bind="item"/>
            </ul>
          </div>
          <div slot="trigger">
            <ActionButton v-bind="action" />
          </div>
        </BootstrapPopover>

        <ActionButton v-else v-bind="action" />
      </li>
    </ul>
  `
    })
], ArticleActions);
export { ArticleActions };
